import { SxProps } from '../types';

export const normalizePx = (val: string | number): string =>
  typeof val === 'number' ? `${val}px` : val;

export const mergeSx = (
  ...sxProps: (SxProps | undefined | false | null)[]
): SxProps | undefined => {
  let sxs: SxProps = [];
  sxProps.forEach((sx) => {
    if (sx) {
      if (Array.isArray(sx)) {
        sxs = (sxs as Array<any>).concat(sx);
      } else {
        (sxs as Array<any>).push(sx);
      }
    }
  });
  if (sxs.length === 0) {
    return;
  }
  if (sxs.length === 1) {
    return sxs[0] as any;
  }
  return sxs;
};

export const createSelectorSx = (
  selector: string,
  styles: SxProps
): SxProps => {
  return { [selector]: styles };
};

// Useful for ensuring type-safety when building sx objects
export const sx = <T extends SxProps>(sx: T): T => {
  return sx;
};

export const negate = (value: string): string => `calc(-1 * ${value})`;

/**
 * CSS-var-safe substitute for MUI `alpha()` (via `color-mix`).
 * MUI `alpha()` needs a resolved hex and breaks on `var(--token)`.
 *
 * Use for translucent washes that have no semantic token yet (e.g. green.50 @ 0.4).
 * Do not replace those washes with solid tokens like `*Subtle` — opacity is intentional.
 * Prefer a real wash/surface token once design adds one.
 */
export const withAlpha = (color: string, opacity: number): string =>
  `color-mix(in srgb, ${color} ${opacity * 100}%, transparent)`;
